import axios from '../../../../shared/axios/axios';
import originAxios from 'axios';

import * as actionTypes from '../constants/actionTypes';

import { stringToArrayBuffer, isGuid, validateObj } from '../../../../shared/utils';
import { errorText } from '../../../../shared/constants/errorText';

const getPrefilledFormStart = () => {
  return {
    type: actionTypes.FORM_EDITOR_GET_PREFILLED_FORM_START,
  };
};

const getPrefilledFormSuccess = (data) => {
  return {
    type: actionTypes.FORM_EDITOR_GET_PREFILLED_FORM_SUCCESS,
    data: data,
  };
};

const getPrefilledFormFail = (error) => {
  return {
    type: actionTypes.FORM_EDITOR_GET_PREFILLED_FORM_FAIL,
    error: error,
  };
};

let getPrefilledFormCancel;
export const getPrefilledForm = ({ data, isUserForm, originalFileId, isCustomForm, isAdditionalFile }) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getPrefilledFormStart());
      let url = `/form-editor/get-prefilled-form`;

      if (typeof getPrefilledFormCancel == 'function') {
        getPrefilledFormCancel(errorText.canceledByFetchingNewData);
      }

      if (data?.formId) {
        url += `?fileId=${data.formId}`;

        url += `&truckingCompanyId=${data.truckingCompanyId}`;

        if (isGuid(data.quoteRequestId)) {
          url += `&quoteRequestId=${data.quoteRequestId}`;
        }

        if (isGuid(data.policyId)) {
          url += `&policyId=${data.policyId}`;
        }

        if (isCustomForm) {
          url += `&isCustomForm=${isCustomForm}`;
        }

        if (isUserForm) {
          url += `&isUserForm=${isUserForm}`;
          url += `&originalFileId=${originalFileId}`;
        }

        if (isAdditionalFile) {
          url += `&isAdditionalFile=${isAdditionalFile}`;
        }
      }

      axios
        .post(url, validateObj(data), {
          cancelToken: new originAxios.CancelToken((cancel) => {
            getPrefilledFormCancel = cancel;
          }),
        })
        .then((response) => {
          if (response.data?.fileBytes) {
            response.data.fileBytes = stringToArrayBuffer(response.data?.fileBytes);
          }

          dispatch(getPrefilledFormSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          if (originAxios.isCancel(err) && err.message === errorText.canceledByFetchingNewData) {
            resolve(err);
          } else {
            dispatch(getPrefilledFormFail(err));
            reject(err);
          }
        });
    });
  };
};

const savePdfFormStart = () => {
  return {
    type: actionTypes.FORM_EDITOR_SAVE_PDF_FORM_START,
  };
};

const savePdfFormSuccess = (data) => {
  return {
    type: actionTypes.FORM_EDITOR_SAVE_PDF_FORM_SUCCESS,
    data: data,
  };
};

const savePdfFormFail = (error) => {
  return {
    type: actionTypes.FORM_EDITOR_SAVE_PDF_FORM_FAIL,
    error: error,
  };
};

export const savePdfForm = (formData) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(savePdfFormStart());
      const url = `/form-editor/save-pdf-form`;

      axios
        .post(url, validateObj(formData))
        .then((response) => {
          dispatch(savePdfFormSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(savePdfFormFail(err));
          reject(err);
        });
    });
  };
};

const getFormParametersStart = () => {
  return {
    type: actionTypes.FORM_EDITOR_GET_FORM_PARAMETERS_START,
  };
};

const getFormParametersSuccess = (data) => {
  return {
    type: actionTypes.FORM_EDITOR_GET_FORM_PARAMETERS_SUCCESS,
    data: data,
  };
};

const getFormParametersFail = (error) => {
  return {
    type: actionTypes.FORM_EDITOR_GET_FORM_PARAMETERS_FAIL,
    error: error,
  };
};

export const getFormParameters = (params) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getFormParametersStart());
      const url = `/form-editor/get-form-parameters`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getFormParametersSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getFormParametersFail(err));
          reject(err);
        });
    });
  };
};

const getPoliciesByIdsStart = () => {
  return {
    type: actionTypes.FORM_EDITOR_GET_POLICIES_BY_IDS_START,
  };
};

const getPoliciesByIdsSuccess = (data) => {
  return {
    type: actionTypes.FORM_EDITOR_GET_POLICIES_BY_IDS_SUCCESS,
    data,
  };
};

const getPoliciesByIdsFail = (error) => {
  return {
    type: actionTypes.FORM_EDITOR_GET_POLICIES_BY_IDS_FAIL,
    error,
  };
};

export const getPoliciesByIds = (policiesIds) => {
  return (dispatch) => {
    dispatch(getPoliciesByIdsStart());

    const url = `/form-editor/get-policies-by-ids`;

    axios
      .post(url, validateObj({ policiesIds }))
      .then((response) => {
        dispatch(getPoliciesByIdsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getPoliciesByIdsFail(err));
      });
  };
};

const getAcordLookupStart = () => {
  return {
    type: actionTypes.FORM_EDITOR_GET_ACORD_LOOKUP_START,
  };
};

const getAcordLookupSuccess = (data) => {
  return {
    type: actionTypes.FORM_EDITOR_GET_ACORD_LOOKUP_SUCCESS,
    data,
  };
};

const getAcordLookupFail = (error) => {
  return {
    type: actionTypes.FORM_EDITOR_GET_ACORD_LOOKUP_FAIL,
    error,
  };
};

export const getAcordLookup = (params) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getAcordLookupStart());

      const url = `/form-editor/get-acord-lookup`;

      axios
        .get(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(getAcordLookupSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getAcordLookupFail(err));
          reject(err);
        });
    });
  };
};
